import styles from "./tag.module.scss";
import Icon from "../icons/Icon";
import React, { useMemo, useState } from "react";

export type TagSolidThemes = "red0" | "mint0" | "brown0" | "gray50";
export type TagOutlineThemes = "mint500" | "brown200" | "gray200" | "red200" | "red500" | "gray100";
type TagThemes<T> = T extends "solid"
  ? TagSolidThemes
  : T extends "outline"
    ? TagOutlineThemes
    : never;
export type TagTypes = "solid" | "outline";

interface ITagProps<T extends TagTypes> {
  size?: "small" | "medium";
  children?: React.ReactNode;
  className?: string;
  type?: T;
  theme?: TagThemes<T>;
  preComponent?: React.ReactNode;
  postComponent?: React.ReactNode;
  isRound?: boolean; // 원래도 기본적으로 6px 라운드가 적용되어 있음 true일 경우 완전히 둥글게 적용
  isBold?: boolean; // 글자 굵게 처리 여부
  isCircle?: boolean; // 원형태로 처리 여부
  closeable?: boolean;
  onClose?: () => void;
  bacgroundColor?: string; // 테마 색상을 무시하고 직접 색상을 지정할 경우 사용
  color?: string; // 테마 색상을 무시하고 직접 색상을 지정할 경우 사용
  fontFamily?: string; // 폰트 지정
}

const Tag = ({
  size = "medium",
  type = "solid",
  theme = "gray50",
  children,
  preComponent,
  postComponent,
  isRound,
  isBold,
  isCircle,
  closeable,
  onClose,
  bacgroundColor,
  color,
  fontFamily,
}: ITagProps<TagTypes>) => {
  const pathColor = useMemo(() => {
    if (theme.includes("mint")) return "#18B698";
    if (theme.includes("red")) return "#F53F29";
    if (theme.includes("brown")) return "#9D7D54";
    if (theme.includes("gray")) return "#8A8A8A";
    return "";
  }, [theme]);

  const styleTag = `
	path{
		stroke: ${pathColor}
	}
  `;

  const [isShow, setIsShow] = useState(true);

  const IconXG900Memo = React.memo(({ styleTag }: { styleTag: string }) => (
    <Icon name="XG900" size={18} styleTag={styleTag} />
  ));
  const IconXG900 = useMemo(() => <IconXG900Memo styleTag={styleTag} />, [styleTag]);

  return (
    isShow &&
    IconXG900 && (
      <div
        className={`${styles["tag"]} ${styles[size]} ${styles[type]} ${styles[theme]} ${isRound && !isCircle ? styles["round"] : ""} ${isCircle ? styles["circle"] : ""} ${isBold ? styles["bold"] : ""}`}
        style={{
          backgroundColor: bacgroundColor || "",
          color: color || "",
          fontFamily: fontFamily || "inherit",
        }}
      >
        {preComponent && preComponent}
        {children}
        {closeable && (
          <button
            onClick={() => {
              setIsShow(false);
              onClose && onClose();
            }}
            className={styles["close"]}
          >
            {IconXG900}
          </button>
        )}
        {postComponent && postComponent}
      </div>
    )
  );
};

export default Tag;
